/*!js-cookiev3.0.5*/
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self,function(){var n=e.Cookies,o=e.Cookies=t();o.noConflict=function(){return e.Cookies=n,o}}())}(this,(function(){"use strict";function e(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)e[o]=n[o]}return e}var t=function t(n,o){function r(t,r,i){if("undefined"!=typeof document){"number"==typeof(i=e({},o,i)).expires&&(i.expires=new Date(Date.now()+864e5*i.expires)),i.expires&&(i.expires=i.expires.toUTCString()),t=encodeURIComponent(t).replace(/%(2[346B]|5E|60|7C)/g,decodeURIComponent).replace(/[()]/g,escape);var c="";for(var u in i)i[u]&&(c+="; "+u,!0!==i[u]&&(c+="="+i[u].split(";")[0]));return document.cookie=t+"="+n.write(r,t)+c}}return Object.create({set:r,get:function(e){if("undefined"!=typeof document&&(!arguments.length||e)){for(var t=document.cookie?document.cookie.split("; "):[],o={},r=0;r<t.length;r++){var i=t[r].split("="),c=i.slice(1).join("=");try{var u=decodeURIComponent(i[0]);if(o[u]=n.read(c,u),e===u)break}catch(e){}}return e?o[e]:o}},remove:function(t,n){r(t,"",e({},n,{expires:-1}))},withAttributes:function(n){return t(this.converter,e({},this.attributes,n))},withConverter:function(n){return t(e({},this.converter,n),this.attributes)}},{attributes:{value:Object.freeze(o)},converter:{value:Object.freeze(n)}})}({read:function(e){return'"'===e[0]&&(e=e.slice(1,-1)),e.replace(/(%[\dA-F]{2})+/gi,decodeURIComponent)},write:function(e){return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,decodeURIComponent)}},{path:"/"});return t}));

function queryDomNodes(selectors = {}, context = document) {
  const domNodes = Object.entries(selectors).reduce((acc, [name, selector]) => {
    const findOne = typeof selector === "string";
    const queryMethod = findOne ? "querySelector" : "querySelectorAll";
    const sl = findOne ? selector : selector[0];

    if (context) {
      acc[name] = context[queryMethod](sl);
    }
    if (!findOne && acc[name]) {
      acc[name] = [...acc[name]];
    }
    return acc;
  }, {});
  return domNodes;
}

const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    
    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}
// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}
function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
		)
	);
}
// How long you want the animation to take, in ms
const animationDuration = 2000;
// Calculate how long each ‘frame’ should last if we want to update the animation 60 times per second
const frameDuration = 1000 / 60;
// Use that to calculate how many frames we need to complete the animation
const totalFrames = Math.round( animationDuration / frameDuration );
// An ease-out function that slows the count as it progresses
const easeOutQuad = t => t * ( 2 - t );

// The animation function, which takes an Element
const animateCountUp = el => {
	let frame = 0;
	
	
	//// Scientific notation is not supported.
	function countDecimals(x) {
		if (x && x % 1) {
			return x.toString().length - x.toString().indexOf('.') - 1 || 0;
		}

		return 0;
	};

	const countTo = el.dataset.percent;
	const decimalPoints = countDecimals(countTo);

	// Start the animation running 60 times per second
	const counter = setInterval( () => {
		frame++;
		// Calculate our progress as a value between 0 and 1
		// Pass that value to our easing function to get our
		// progress on a curve
		const progress = easeOutQuad( frame / totalFrames );
		// Use the progress value to calculate the current count
		const currentCount = (countTo * progress).toFixed(decimalPoints);
		// If the current count has changed, update the element
		if (parseFloat( el.textContent ) !== currentCount) {
			el.textContent = currentCount;
		}

		// If we’ve reached our last frame, stop the animation
		if ( frame === totalFrames ) {
			clearInterval( counter );
		}
	}, frameDuration );
};
function pauseAllMedia() {
	document.querySelectorAll('.js-youtube').forEach((video) => {
		video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
	});

	document.querySelectorAll('.js-vimeo').forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', '*');
	});
	
	document.querySelectorAll('video').forEach((video) => video.pause());

	document.querySelectorAll('product-model').forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause();
	});
}
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

function throttle(fn, delay) {
	let lastCall = 0;
	return function (...args) {
		const now = new Date().getTime();
		if (now - lastCall < delay) {
			return;
		}
		lastCall = now;
		return fn(...args);
	};
}

function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
	};
}

/** Shopify Common JS */
if (typeof window.Shopify == 'undefined') {
	window.Shopify = {};
}

/** Money format handler */
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
	if (typeof cents == 'string') { cents = cents.replace('.',''); }
	let value = '';
	let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
	let formatString = (format || this.money_format);

	function defaultOption(opt, def) {
		return (typeof opt == 'undefined' ? def : opt);
	}

	function formatWithDelimiters(number, precision, thousands, decimal) {
		precision = defaultOption(precision, 2);
		thousands = defaultOption(thousands, ',');
		decimal   = defaultOption(decimal, '.');

		if (isNaN(number) || number == null) { return 0; }

		number = (number/100.0).toFixed(precision);

		let parts   = number.split('.'),
			dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
			cents   = parts[1] ? (decimal + parts[1]) : '';

		return dollars + cents;
	}

	switch(formatString.match(placeholderRegex)[1]) {
		case 'amount':
			value = formatWithDelimiters(cents, 2);
		break;
		case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0);
		break;
		case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', ',');
		break;
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', ',');
		break;
	}

	return formatString.replace(placeholderRegex, value);
};

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
	options = options || {};
	var method = options['method'] || 'post';
	var params = options['parameters'] || {};

	var form = document.createElement('form');
	form.setAttribute('method', method);
	form.setAttribute('action', path);

	for (var key in params) {
		var hiddenField = document.createElement('input');
		hiddenField.setAttribute('type', 'hidden');
		hiddenField.setAttribute('name', key);
		hiddenField.setAttribute('value', params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};


class DeferredMedia extends HTMLElement {
    constructor() {
        super();

        this.elementVisible = false;

        this.thresholds = [0.0];

        this.rootMargin = "0px";

        this.delay = 100;

        this.autoplayOnReveal = this.dataset.autoplayOnReveal;

		this.playOnHover = this.dataset.playOnHover;

		this.playPromise;

        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        poster.addEventListener('click', this.loadContent.bind(this));

		if(this.playOnHover == 'true') {
			this.addEventListener('mouseover', this.playOnMouseover.bind(this));
			this.addEventListener('mouseleave', this.pauseOnMouseleave.bind(this));
		}
    }

    connectedCallback() {
        if (this.autoplayOnReveal == 'true') {
            this.intersectionObserver = new IntersectionObserver(
                this.autoplayObserver.bind(this),
                {
                    root: document.rootElement,
                    rootMargin: this.rootMargin,
                    threshold: this.thresholds,
                    delay: this.delay,
                }
            );

            this.intersectionObserver.observe(this);
        }
    }

    loadContent(focus = false) {
		if (!this.hasAttribute("data-disable-all-media-pause")) {
		   window.pauseAllMedia();
		} 

        if (!this.getAttribute('loaded')) {
            const content = document.createElement('div');
            content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

            this.setAttribute('loaded', true);
            const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
            if (focus) deferredElement.focus();
            if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
                deferredElement.play();
            }

			return deferredElement;
        }
    }

	autoplayObserver(entries) {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                //if(this.getAttribute('loaded')) entry.target.querySelector('video').pause();
            } else {
                this.elementVisible = true;

                if (!this.getAttribute('loaded')) {
                    this.loadContent.call(this);
                };

                entry.target.querySelector('video').play();
                this.intersectionObserver.disconnect();
            }
        });
    }

	playOnMouseover(event) {
        if (!this.getAttribute('loaded')) {
			let deferredElement = this.loadContent.call(this);
			deferredElement.play();
		}else {
			this.playPromise = this.querySelector('video').play();
		};
    }

	pauseOnMouseleave(event) {
		//window.pauseAllMedia();
		if (this.playPromise !== undefined) {
			this.playPromise.then(_ => {
				// Automatic playback started!
				// Show playing UI.
				// We can now safely pause video...
				this.querySelector('video').pause();
			})
			.catch(error => {
				console.log('Video play error');
			});
		}
    }
}
customElements.define('deferred-media', DeferredMedia);

class VariantSelects extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.addEventListener('change', (event) => {
			this.event = event;
			this.onVariantChange();
		});

	}

	onVariantChange() {
		this.updateOptions();
		this.updateMasterId();
		this.toggleAddButton(true, '', false);
		this.updatePickupAvailability();
		this.removeErrorMessage();
		this.updateVariantStatuses();

		if (!this.currentVariant) {
			this.toggleAddButton(true, '', true);
			this.setUnavailable();
		} else {
			this.updateMedia();
			this.updateURL();
            this.updateProductInfo();
			this.renderProductInfo();
			this.updateShareUrl();
		}
	}
	updateOptions() {
		this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
	}

	updateMasterId() {
		this.currentVariant = this.getVariantData().find((variant) => {
			return !variant.options.map((option, index) => {
				return this.options[index] === option;
			}).includes(false);
		});
	}

	updateMedia() {
		if (!this.currentVariant) return;

		if (!this.currentVariant.featured_media) return;

		const slideIndex = this.currentVariant?.featured_media?.position || 0;

		const productMediaGallerie = document.getElementById('product-gallery');

		if(productMediaGallerie !== null) {
			let productMediaSlider = productMediaGallerie.swiper;
			productMediaSlider?.slideToLoop?.(slideIndex - 1);
		}
	}

    updateProductInfo() {
		if (!this.currentVariant) return;

		let spanPrice = this.parentNode.querySelector("form .product-form__buttons .PdpHero-atc-price");

		if(spanPrice) {
			spanPrice.innerHTML = '&nbsp- ' + Shopify.formatMoney(this.currentVariant.price, window.moneyFormat); 

			this.fieldsets = this.querySelectorAll('.js.product-form__input input');

			this.variantDataset = Array.from(this.fieldsets).find((radio) => radio.checked).dataset;

			let productOptionDescription = this.querySelector('.js-pdp-hero-option');

			if(this.variantDataset.supply) {
				productOptionDescription.textContent = ': ' + this.variantDataset.supply;
			} else {
				productOptionDescription.textContent = ': ' + this.currentVariant.title;
			};

			document.querySelectorAll('.product-details .nav').forEach((item) => {
				if(item.id == `nav-tab-${this.currentVariant.id}`) {
					item.classList.add('active');
				} else {
					item.classList.remove('active');
				}
			});

			document.querySelectorAll('.product-details .tab-content').forEach((item) => {
				if(item.id == `nav-tabContent-${this.currentVariant.id}`) {
					item.classList.add('active');
				} else {
					item.classList.remove('active');
				}
			});
		}

		let payLaterPrice = document.getElementById("payLaterPrice");
		if(payLaterPrice) {
			payLaterPrice.textContent = Shopify.formatMoney(this.currentVariant.price / payLaterPrice.dataset.paymentCount, window.moneyFormat);
		}
	}

	updateURL() {
		if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
		window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}

	updateShareUrl() {
		const shareButton = document.getElementById(`Share-${this.dataset.section}`);
		if (!shareButton || !shareButton.updateUrl) return;
		shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
	}

	updateVariantStatuses() {
		const selectedOptionOneVariants = this.variantData.filter(
			(variant) => this.querySelector(':checked').value === variant.option1
		);

		const inputWrappers = [...this.querySelectorAll('.product-form__input')];
		inputWrappers.forEach((option, index) => {
			if (index === 0) return;
			const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
			const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
			const availableOptionInputsValue = selectedOptionOneVariants
				.filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
				.map((variantOption) => variantOption[`option${index + 1}`]);
			this.setInputAvailability(optionInputs, availableOptionInputsValue);
		});
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
				input.innerText = input.getAttribute('value');
			} else {
				input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
			}
		});
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector('pickup-availability');
		if (!pickUpAvailability) return;

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id);
		} else {
			pickUpAvailability.removeAttribute('available');
			pickUpAvailability.innerHTML = '';
		}
	}

	removeErrorMessage() {
		const section = this.closest('section');
		if (!section) return;

		const productForm = section.querySelector('product-form');
		if (productForm) productForm.handleErrorMessage();
	}

    renderProductInfo() {
        const requestedVariantId = this.currentVariant.id;
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

		const addToCartButton = this.parentElement.querySelector('button.quick-add__submit.card-variant-btn');
		document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, form.quick-add-variant`
		).forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]');

			if (!this.currentVariant) {
				this.currentVariant = this.querySelector('.product-variant-id');
			}

			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event('change', { bubbles: true }));
			// add to cart when you click on the checkbox/selec on grid
			setTimeout(() => {
				if (typeof(addToCartButton) != 'undefined' && addToCartButton != null){
					addToCartButton.click();
				}
			}, 301);
		});

        fetch(
          `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
           }`
        ).then((response) => response.text())
            .then((responseText) => {
                // prevent unnecessary ui changes from abandoned selections
                if (this.currentVariant.id !== requestedVariantId) return;

                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const destination = document.getElementById(`price-${this.dataset.section}`);

                const source = html.getElementById(
                    `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );

                const skuSource = html.getElementById(
                    `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );

                const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);

                const inventorySource = html.getElementById(
                    `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );

                const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

                if (source && destination) destination.innerHTML = source.innerHTML;
                if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;

                if (skuSource && skuDestination) {
                    skuDestination.innerHTML = skuSource.innerHTML;
                    skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
                }

                const price = document.getElementById(`price-${this.dataset.section}`);

                if (price) price.classList.remove('visibility-hidden');

                if (inventoryDestination)
                    inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

                const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);

                this.toggleAddButton(
                    addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
                    window.variantStrings.soldOut
                );

                publish(PUB_SUB_EVENTS.variantChange, {
                    data: {
                        sectionId,
                        html,
                        variant: this.currentVariant,
                    },
                });
            });
    }

	toggleAddButton(disable = true, text, modifyClass = true) {
		const productForm = document.getElementById(`product-form-${this.dataset.section}`);
		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]');
		const addButtonText = productForm.querySelector('[name="add"] > span');
		if (!addButton) return;

		if (disable) {
			addButton.setAttribute('disabled', 'disabled');
			if (text) addButtonText.textContent = text;
		} else {
			addButton.removeAttribute('disabled');
			addButtonText.textContent = window.variantStrings.addToCart;
		}

		if (!modifyClass) return;
	}

	setUnavailable() {
		const button = document.getElementById(`product-form-${this.dataset.section}`);
		const addButton = button.querySelector('[name="add"]');
		const addButtonText = button.querySelector('[name="add"] > span');
		const price = document.getElementById(`price-${this.dataset.section}`);
		const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
		const sku = document.getElementById(`Sku-${this.dataset.section}`);

		if (!addButton) return;
		addButtonText.textContent = window.variantStrings.unavailable;
		if (price) price.classList.add('visibility-hidden');
		if (inventory) inventory.classList.add('visibility-hidden');
		if (sku) sku.classList.add('visibility-hidden');
	}

	getVariantData() {
		this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
	constructor() {
		super();
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
				input.classList.remove('disabled');
			} else {
				input.classList.add('disabled');
			}
		});
	}

	updateOptions() {
		this.options = [
			Array.from(this.querySelectorAll('.js.product-form__input input')).find((radio) => radio.checked).value
		];
	}
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
    observer = undefined;

	constructor() {
		super();
	}
    
    connectedCallback() {
        this.initializeRecommendations(this.dataset.productId);
    }
    
    initializeRecommendations(productId) {
        this.observer?.unobserve(this);
        this.observer = new IntersectionObserver(
            (entries, observer) => {
                if (!entries[0].isIntersecting) return;
                observer.unobserve(this);
                this.loadRecommendations(productId);
            },
            { rootMargin: '0px 0px 400px 0px' }
        );

        this.observer.observe(this);
    }

    loadRecommendations(productId) {
        let intent = this.dataset.intent || 'related';

        fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}&intent=${intent}`)
            .then((response) => response.text())
            .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('product-recommendations');

                if (recommendations?.innerHTML.trim().length) {
                    this.innerHTML = recommendations.innerHTML;
                }

                if (html.querySelector('.grid__item')) {
                    this.classList.add('product-recommendations--loaded');
                }
            }).catch((e) => {
                console.error(e);
            });
    }

}
customElements.define('product-recommendations', ProductRecommendations);

if (!customElements.get("select-component")) {
	class SelectComponent extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				elSelectNative: ".js-selectNative",
				elSelectCustom: ".js-selectCustom",
				elSelectCustomBox: ".select-custom--trigger",
				elSelectCustomOpts: ".select-custom--options",
				elSelectCustomTriggerText: ".select-custom--trigger-text",
				customOptionList: [".select-custom--option"],
			};

			this.domNodes = queryDomNodes(this.selectors, this);
			this.optionChecked = "";

			this.setDefaultValue();
			this.initSelect();
		};

		setDefaultValue() {
			const { elSelectNative } = this.domNodes;
			const value = elSelectNative.options[elSelectNative.selectedIndex].value;
			const text = elSelectNative.options[elSelectNative.selectedIndex].text;
			this.updateCustomSelectChecked(value, text);
		}

		initSelect() {
			//this.classList.remove("m:hidden");
			const { elSelectNative, elSelectCustom, elSelectCustomBox } = this.domNodes;

			elSelectCustomBox.addEventListener("click", () => {
				const isClose = !elSelectCustom.classList.contains("isActive");
				if (isClose) {
					this.openSelect();
				} else {
					this.closeSelect();
				}
			});

			this.domNodes.customOptionList.forEach((option) => {
				option.addEventListener("click", (e) => {
					const value = e.target.getAttribute("data-value");
					elSelectNative.value = value;
					this.closeSelect();
					this.updateCustomSelectChecked(value, e.target.textContent);
					elSelectNative.dispatchEvent(new Event("change"));
					elSelectNative.dispatchEvent(new Event("click"));
				});
			});
		}

		openSelect() {
			const allCustomSelect = document.querySelectorAll("select-component");
			document.addEventListener("click", (e) => this.handleClickOutside(e));
			if (allCustomSelect.length > 0) {
				allCustomSelect.forEach((select) => {
					select.closeSelect();
				});
			}
			this.domNodes.elSelectCustom.classList.add("isActive");
		}

		closeSelect() {
			this.domNodes.elSelectCustom.classList.remove("isActive");
		}

		updateCustomSelectChecked(value, text) {
			const { elSelectCustomOpts, elSelectCustomTriggerText } = this.domNodes;
			const prevValue = this.optionChecked;
			const elPrevOption = elSelectCustomOpts.querySelector(`[data-value="${prevValue}"`);

			const elOption = elSelectCustomOpts.querySelector(`[data-value="${value}"`);

			if (elPrevOption) {
			elPrevOption.classList.remove("isActive");
			}

			if (elOption) {
			elOption.classList.add("isActive");
			}

			elSelectCustomTriggerText.textContent = text;
			this.optionChecked = value;
		}

		handleClickOutside(e) {
			const { elSelectCustom } = this.domNodes;
			const didClickedOutside = !elSelectCustom.contains(e.target);
			if (didClickedOutside) {
				this.closeSelect();
			}
		}
	}

	customElements.define("select-component", SelectComponent);
}